















import { Component, Watch, Vue } from 'vue-property-decorator';
import { State, Getter, Mutation} from 'vuex-class';
import { FunctionsState } from '../stores/functions/types';
import { Functions, Function, Post } from '../Classes/Entities';
import { TaskContent } from '../Classes/Entities/Chat/TaskContent';
import TalkThreadChats from '../components/talk/TalkThreadChats.vue';
import TalkThreadChatForm from '../components/talk/TalkThreadChatForm.vue';

const namespace: string = 'functions';

@Component({
  components: {
    TalkThreadChats,
    TalkThreadChatForm
  },
})
export default class Note extends Vue {
  @State('functions') 
  public functions!: FunctionsState;

  @Getter('functionMap', { namespace }) 
  public functionMap!: Functions;

  @Mutation('getKeys', { namespace }) 
  public getKeys!: any;

  private _task!: Post;

  public get functionId():string{
    return this.$route.params.function_id;
  }

  public get threadList() {
    const functionId:string = this.functionId;
    const postList = this.functionMap.get(functionId).postList;
    return postList.threadList;
  }
  
  private get name(): string {
    const functionId:string = this.functionId;
    const name = this.functionMap.get(functionId).name;
    return name;
  }
}
